import React from 'react';
import { useTranslation, Trans } from 'react-i18next';

import { CompletePetDetailsPetList } from './CompletePetDetailsPetList';

import styles from './CompletePetDetails.module.css';

const PetsIncludedInPeriodSection = ({
  isPetDetailsComplete = () => false,
  isPostSubmissionMode = false,
  onUpdatePetDemographics = () => { },
  pets = [],
}) => {
  const { t } = useTranslation('petDemos');
  const petsCount = pets.length;

  return (
    <>
      <div className={styles.subHeader}>
        <span className={styles.petsCount}>
          <Trans
            components={{
              blue: <span className={styles.count} />,
            }}
            count={petsCount}
            i18nKey="completeInformation.includedInThisPeriod"
            ns="petDemos"
            values={{ petsCount }}
          />
        </span>

        <span className={styles.subNote}>
          {t('completeInformation.subNote')}
        </span>
      </div>

      <CompletePetDetailsPetList
        isPetDetailsComplete={isPetDetailsComplete}
        isPostSubmissionMode={isPostSubmissionMode}
        isRolloverCard={false}
        onUpdatePetDemographics={onUpdatePetDemographics}
        pets={pets}
      />
    </>
  );
};

export { PetsIncludedInPeriodSection };
